import { Spinner } from '@tcweb/connect-ui';
import { children, type Accessor, type ParentComponent, Show } from 'solid-js';

export interface SettingsSectionProps {
  isLoaded?: Accessor<boolean>;
}

export const SettingsSection: ParentComponent<SettingsSectionProps> = (
  props
) => {
  const resolved = children(() => props.children);

  return (
    <Show
      when={props.isLoaded === undefined || props.isLoaded()}
      fallback={<Spinner show={true} />}
    >
      {resolved()}
    </Show>
  );
};
